import { observable, runInAction } from 'mobx'

const GlobalState = observable({
  isMenuOpen: false,
  isLocaleOpen: false,
  currentLocale: {
    country: 'Ukraine',
    lang: 'Українська',
  },
  video: {
    src: '',
    show: false,
    poster: '',
    isPlay: false,
  },
  locoScroll: null,
  isCountriesOpen: false,
  isCoopShow: false,
  isCareerCoopShow: false,
  domain: '',
})

export default GlobalState

export const changeCoopState = () => {
  runInAction(() => {
    GlobalState.isCoopShow = !GlobalState.isCoopShow
  })
}

export const changeCareerCoopState = () => {
  runInAction(() => {
    GlobalState.isCareerCoopShow = !GlobalState.isCareerCoopShow
  })
}

export const changeCountriesState = () => {
  runInAction(() => {
    GlobalState.isCountriesOpen = !GlobalState.isCountriesOpen
  })
}

export const changeMenuState = () => {
  runInAction(() => {
    GlobalState.isMenuOpen = !GlobalState.isMenuOpen
  })
}
export const changeLocaleState = () => {
  if (GlobalState.isMenuOpen) {
    runInAction(() => {
      GlobalState.isMenuOpen = !GlobalState.isMenuOpen
    })
  }
  runInAction(() => {
    GlobalState.isLocaleOpen = !GlobalState.isLocaleOpen
  })
}

export const setLang = () => {
  if (localStorage.getItem('lang')) {
    const lang = JSON.parse(localStorage.getItem('lang')!)
    runInAction(() => {
      GlobalState.currentLocale = lang
    })
  } else {
    localStorage.setItem(
      'lang',
      JSON.stringify({
        country: GlobalState.currentLocale.country,
        lang: GlobalState.currentLocale.lang,
      }),
    )
  }
}

export const changeLocale = (lang: string, country: string) => {
  localStorage.setItem(
    'lang',
    JSON.stringify({
      country: country,
      lang: lang,
    }),
  )

  let path = ''
  if (country.includes('Ukr')) {
    if (lang.includes('En')) {
      path =
        '/en' +
        window.location.pathname
          .replaceAll('/uk/', '')
          .replaceAll('/en/', '')
          .replaceAll('/ru/', '')
      if (path == '/en') {
        path += '/'
      }
    } else {
      path = window.location.pathname
        .replaceAll('/uk/', '')
        .replaceAll('/en/', '')
        .replaceAll('/ru/', '')

      path = '/' + path
    }
  }
  window.location.href = path
}

export const watchVideo = (src: string, poster: string) => {
  runInAction(() => {
    GlobalState.video = {
      src: src,
      show: !GlobalState.video.show,
      poster: poster,
      isPlay: false,
    }
  })
}
